function setAdminApi(path) {
  let global = '/api/';
  return global + path;
}

const api = {
  // 广告
  getadInfo: setAdminApi('ad/info'), //启动页广告


  //
  // 举报
  getDictList: setAdminApi('common/dictList'), //获取举报类型\危害类型
  postUploadFile:setAdminApi('upload/upload_file'),//上传文件
  postHarmfulReportSave: setAdminApi('common/harmfulReportSave'), //提交举报



  // getDictList: 'https://rmtzx.fsxrmtzx.com/common/dictList', //获取举报类型\危害类型
  // postUploadFile:'https://rmtzx.fsxrmtzx.com/upload/upload_file',//上传文件
  // postHarmfulReportSave: 'https://rmtzx.fsxrmtzx.com/common/harmfulReportSave', //提交举报

}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js